import { useState } from "react";
import { useTitleStore } from "store";
import { CreateTitleCompanyFunction } from "types/functions/createTitleCompany";
import { BaseAsyncHook } from "types/hooks";

interface UseCreateTitleCompany extends BaseAsyncHook {
  loading: boolean;
  error: boolean;
  errorData: any | null;
  createTitleCompany: CreateTitleCompanyFunction;
}

export const useCreateTitleCompany = (): UseCreateTitleCompany => {
  const _createTitleCompany = useTitleStore(
    (state) => state.createTitleCompany
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorData, setErrorData] = useState<unknown | null>(null);

  const createTitleCompany = async (
    ...args: Parameters<CreateTitleCompanyFunction>
  ) => {
    try {
      setIsLoading(true);
      setIsError(false);
      setErrorData(null);
      const parameters = args[0];
      await _createTitleCompany(parameters);
      return true;
    } catch (error) {
      setIsError(true);
      setErrorData(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error: isError,
    errorData: errorData,
    loading: isLoading,
    createTitleCompany,
  };
};
